import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import { setProfilePw } from "@/services/ccApi";
import { sendProfileOtp, verifyProfileOtp, resetOtp, otpErr, PROFILE_OTP_PHONE } from "@/services/otp";

// Set or change the profile password. Always gated by an OTP to the owner number (verified server-side).
export function ProfilePasswordOtp({ mode = "set", onDone }) {
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [busy, setBusy] = useState(false);
  const p = mode === "change" ? "change" : "new";

  const sendOtp = async () => {
    if (newPw.length < 4) return toast.error("Password must be at least 4 characters");
    if (newPw !== confirmPw) return toast.error("Passwords do not match");
    setBusy(true);
    try { await sendProfileOtp("recaptcha-container"); setOtpSent(true); toast.success(`OTP sent to ${PROFILE_OTP_PHONE}`); }
    catch (e) { toast.error(otpErr(e)); resetOtp(); }
    finally { setBusy(false); }
  };
  const save = async () => {
    setBusy(true);
    try {
      const token = await verifyProfileOtp(otp.trim());
      await setProfilePw(newPw, token);
      toast.success(mode === "change" ? "Profile password changed" : "Profile password set");
      setOtpSent(false); setNewPw(""); setConfirmPw(""); setOtp("");
      onDone?.();
    } catch (e) { toast.error(e?.response?.data?.detail || otpErr(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-3" data-testid={`${p}-pw-form`}>
      <p className="text-sm text-muted-foreground">An OTP will be sent to <span className="font-mono">{PROFILE_OTP_PHONE}</span> to confirm.</p>
      <div className="space-y-1.5"><Label>New profile password</Label><Input type="password" data-testid={`${p}-profile-pw`} value={newPw} onChange={(e) => setNewPw(e.target.value)} disabled={otpSent} /></div>
      <div className="space-y-1.5"><Label>Confirm new password</Label><Input type="password" data-testid={`${p}-profile-pw-confirm`} value={confirmPw} onChange={(e) => setConfirmPw(e.target.value)} disabled={otpSent} /></div>
      {!otpSent ? (
        <Button className="w-full gap-1.5" onClick={sendOtp} disabled={busy} data-testid={`${p}-send-otp-btn`}><Icons.Smartphone className="h-4 w-4" /> Send OTP</Button>
      ) : (
        <>
          <div className="space-y-1.5"><Label>Enter OTP</Label><Input data-testid={`${p}-otp-input`} value={otp} onChange={(e) => setOtp(e.target.value)} placeholder="6-digit code" /></div>
          <div className="flex gap-2">
            <Button className="flex-1 gap-1.5" onClick={save} disabled={busy || !otp.trim()} data-testid={`${p}-verify-otp-btn`}><Icons.ShieldCheck className="h-4 w-4" /> Verify & save</Button>
            <Button variant="ghost" onClick={() => { setOtpSent(false); resetOtp(); }} data-testid={`${p}-otp-cancel`}>Cancel</Button>
          </div>
        </>
      )}
    </div>
  );
}
